import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import SecurityOneScanFace from "./SecurityOneScanFace";
const SecurityOneVisitorAttendance = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const shortcuts = [
    { icon: "detection_and_zone", label: "Face Attendance" },
    { icon: "help", label: "Pre Approve" },
    { icon: "how_to_reg", label: "Visitors List" },
  ];

  const [showPopup, setShowPopup] = useState(false);
  return (
    <div>
      <div className="security-one-home-container">
        {/* SEARCH SECTION START */}
        <div className="security-one-home-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="gray"
          >
            <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
          </svg>
          <input
            type="search"
            autoComplete=""
            placeholder="Search visitors by name, phone number"
          />
        </div>
        {/* SEARCH SECTION END */}

        <div className="security-one-quick-menus-container">
          <div className="security-one-home-shortcuts">
            {shortcuts.map((item, index) => (
              <div
                className="security-one-home-shortcuts-item"
                key={index}
                onClick={() => {
                  if (user && index === 0) {
                    setShowPopup(true);
                  } else {
                    navigate("/login");
                  }
                  if (index === 1) navigate("/host-pre-approve");
                  if (index === 2) navigate("/host-home");
                }}
              >
                <span className="material-symbols-outlined">{item.icon}</span>

                <span className="security-one-home-label">{item.label}</span>
              </div>
            ))}
          </div>

          {/* Pass showPopup and setShowPopup to the child component */}
          <SecurityOneScanFace
            showPopup={showPopup}
            setShowPopup={setShowPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default SecurityOneVisitorAttendance;
